"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Anchor = _interopRequireDefault(require("../Anchor"));

var _AnchorTypes = require("../Anchor/AnchorTypes");

var _plus = _interopRequireDefault(require("@dcl/icons/lib/ui/plus"));

var _classNames = _interopRequireDefault(require("../../utilities/classNames"));

var _LinkTypes = require("./LinkTypes");

var _NewTabIcon = require("./icon/NewTabIcon");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Link = function Link(_ref) {
  var ariaLabel = _ref.ariaLabel,
      block = _ref.block,
      children = _ref.children,
      contentLocation = _ref.contentLocation,
      download = _ref.download,
      href = _ref.href,
      iconLeft = _ref.iconLeft,
      iconRight = _ref.iconRight,
      modalLabel = _ref.modalLabel,
      newWindow = _ref.newWindow,
      type = _ref.type,
      innerRef = _ref.innerRef;
  var getClassName = (0, _classNames["default"])(Link.displayName);
  var withIcon = iconLeft || iconRight || type !== "inline";
  /** TODO: no default case on switch as the instantiated variable remains untouched */

  var icon = iconRight || iconLeft;

  switch (type) {
    case _LinkTypes.LinkTypes.ACTION:
      icon = /*#__PURE__*/_react["default"].createElement(_plus["default"], null);
      break;

    case _LinkTypes.LinkTypes.PRIMARY:
    case _LinkTypes.LinkTypes.SECONDARY:
      icon = /*#__PURE__*/_react["default"].createElement(_NewTabIcon.NewTabIcon, null);
      break;
  }

  var Wrapper = function Wrapper(props) {
    return /*#__PURE__*/_react["default"].createElement(_Anchor["default"], {
      className: getClassName({
        modifiers: (0, _classnames["default"])({
          block: block,
          iconLeft: iconLeft,
          withIcon: withIcon
        }, type)
      }),
      contentLocation: contentLocation,
      download: download,
      fallbackElementTag: _AnchorTypes.AnchorElementTags.SPAN,
      href: href,
      innerRef: innerRef,
      modalLabel: modalLabel,
      newWindow: newWindow,
      "aria-label": ariaLabel
    }, props.children);
  };

  if (withIcon) {
    return /*#__PURE__*/_react["default"].createElement(Wrapper, null, iconLeft && icon && /*#__PURE__*/_react["default"].createElement("span", {
      className: getClassName({
        descendantName: "icon"
      })
    }, icon), /*#__PURE__*/_react["default"].createElement("span", {
      className: getClassName({
        descendantName: "inner"
      })
    }, children), !iconLeft && icon && /*#__PURE__*/_react["default"].createElement("span", {
      className: getClassName({
        descendantName: "icon"
      })
    }, icon));
  } // Deliberately without descendants


  return /*#__PURE__*/_react["default"].createElement(Wrapper, null, children);
};

Link.defaultProps = {
  type: "inline"
};
Link.displayName = "Link";
Link.types = _LinkTypes.LinkTypes;
var _default = Link;
exports["default"] = _default;